export default __webpack_public_path__ + "static/media/sanwoOlu.9e12706b.jpg";